import { MutationTree } from 'vuex';
import { Document, Documents, MissingDocument } from '@/models/form/Documents.model';
import { DocumentState, initialState } from '@/store/modules/document/index';
import {
  ADD_DOCUMENT,
  REMOVE_DIRTY_DOCUMENT,
  REMOVE_DOCUMENT,
  SET_DOCUMENTS, SET_DOCUMENTS_ERRORS, SET_LOADING,
  SET_MISSING_DOCUMENTS, SET_REMOVE_MISSING_DOCUMENT_FLAG, SET_UPLOAD_MISSING_DOCUMENT_FLAG,
} from '@/types/documents.types';

const addToDocuments = (state, doc: Document): Documents => {
  if (doc.docName) {
    doc.name = doc.docName;
  }
  switch ('' + doc.docType) {
    case '201':
      return {
        ...state.documents,
        employeeFiles: [...state.documents.employeeFiles, doc],
      };
    case '300':
      return {
        ...state.documents,
        childrenFiles: [...state.documents.childrenFiles, doc],
      };
    case '500':
      return {
        ...state.documents,
        extraIncomeFiles: [...state.documents.extraIncomeFiles, doc],
      };
    case '802':
      return {
        ...state.documents,
        handicapFiles: [...state.documents.handicapFiles, doc],
      };
    case '8022':
      return {
        ...state.documents,
        handicapMonthlyAllowanceFiles: [...state.documents.handicapMonthlyAllowanceFiles, doc],
      };
    case '803':
      return {
        ...state.documents,
        settlementFiles: [...state.documents.settlementFiles, doc],
      };
    case '804':
      return {
        ...state.documents,
        immigrantFiles: [...state.documents.immigrantFiles, doc],
      };
    case '805':
      return {
        ...state.documents,
        unemployedPartnerFiles: [...state.documents.unemployedPartnerFiles, doc],
      };
    case '810':
      return {
        ...state.documents,
        nonCustodyFiles: [...state.documents.nonCustodyFiles, doc],
      };
    case '811':
      return {
        ...state.documents,
        childSupportFiles: [...state.documents.childSupportFiles, doc],
      };
    case '851':
      return {
        ...state.documents,
        incompetentChildFiles: [...state.documents.incompetentChildFiles, doc],
      };
    case '813':
      return {
        ...state.documents,
        soldierFiles: [...state.documents.soldierFiles, doc],
      };
    case '814':
      return {
        ...state.documents,
        academicFiles: [...state.documents.academicFiles, doc],
      };
    case '901':
      return {
        ...state.documents,
        taxCoordsNoIncomeFiles: [...state.documents.taxCoordsNoIncomeFiles, doc],
      };
    case '902':
      return {
        ...state.documents,
        taxCoordsExternalIncomeFiles: [...state.documents.taxCoordsExternalIncomeFiles, doc],
      };
    case '903':
      return {
        ...state.documents,
        taxCoordsApprovedFiles: [...state.documents.taxCoordsApprovedFiles, doc],
      };
    case '816':
      return {
        ...state.documents,
        reserveFiles: [...state.documents.reserveFiles, doc],
      };
    default:
      return state.documents;
  }
};

export const mutations: MutationTree<DocumentState> = {
  [SET_DOCUMENTS]: (state, docs: Document[]) => {
    state.documents = initialState().documents;
    for (const doc of docs) {
      state.documents = addToDocuments(state, doc);
    }
  },

  [SET_MISSING_DOCUMENTS]: (state, missingDocuments: MissingDocument[]) => {
    if (missingDocuments) {
      state.missingDocuments = missingDocuments;
    } else {
      state.missingDocuments = [];
    }
  },

  [ADD_DOCUMENT]: (state, doc: Document) => {
    state.documents = addToDocuments(state, doc);
  },

  [REMOVE_DOCUMENT]: (state, docId: number | string) => {
    const filteredDocuments: Documents = initialState().documents;
    for (const key in state.documents) {
      if (Object.prototype.hasOwnProperty.call(state.documents, key)) {
        filteredDocuments[key] = [
          ...state.documents[key].filter((document: Document) => document.docId !== docId),
        ];
      }
    }
    state.documents = filteredDocuments;
  },

  [REMOVE_DIRTY_DOCUMENT]: (state) => {
    const filteredDocuments: Documents = initialState().documents;
    for (const key in state.documents) {
      if (Object.prototype.hasOwnProperty.call(state.documents, key)) {
        filteredDocuments[key] = [
          ...state.documents[key].filter((document: Document) => !!document.docId),
        ];
      }
    }
    state.documents = filteredDocuments;
  },

  [SET_LOADING]: (state, value: boolean) => {
    state.loadingMode = value;
  },

  [SET_REMOVE_MISSING_DOCUMENT_FLAG]: (state, value: boolean) => {
    state.removeMissingDocumentsFlag = value;
  },

  [SET_UPLOAD_MISSING_DOCUMENT_FLAG]: (state, value: boolean) => {
    state.uploadMissingDocumentsFlag = value;
  },

  [SET_DOCUMENTS_ERRORS]: (state, value: string[]) => {
    state.documentsErrors = value;
  },

};
